import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './LoginPopup.css';

const LoginPopup = ({ onClose, onSuccess }) => {
    const [showEmailForm, setShowEmailForm] = useState(false);
    const [isSignup, setIsSignup] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [consentAccepted, setConsentAccepted] = useState(false);
    const { loginWithGoogle, loginWithEmail, signupWithEmail } = useAuth();

    const isMounted = React.useRef(true);

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleGoogleSignIn = async () => {
        try {
            setError('');
            setLoading(true);
            await loginWithGoogle();
            if (isMounted.current) {
                onSuccess();
            }
        } catch (error) {
            console.error('Google sign-in error:', error);
            if (isMounted.current) {
                setError('Erro ao fazer login com Google. Tente novamente.');
            }
        } finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    };

    const handleEmailSubmit = async (e) => {
        e.preventDefault();

        try {
            setError('');
            setLoading(true);

            if (isSignup) {
                await signupWithEmail(email, password);
            } else {
                await loginWithEmail(email, password);
            }

            onSuccess();
        } catch (error) {
            console.error('Email auth error:', error);
            if (error.code === 'auth/user-not-found') {
                setError('Usuário não encontrado');
            } else if (error.code === 'auth/wrong-password') {
                setError('Senha incorreta');
            } else if (error.code === 'auth/email-already-in-use') {
                setError('Email já está em uso');
            } else {
                setError('Erro ao autenticar. Tente novamente.');
            }
        }
        setLoading(false);
    };

    return (
        <div className="popup-overlay" onClick={onClose}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <button className="popup-close" onClick={onClose}>×</button>

                <div className="popup-header">
                    <h2>🎯 Faça login para continuar</h2>
                    <p>Acesse ofertas exclusivas e acompanhe seus favoritos</p>
                </div>

                {error && (
                    <div className="popup-error">
                        <i className="fas fa-exclamation-circle"></i>
                        {error}
                    </div>
                )}

                {!showEmailForm ? (
                    <div className="popup-body">
                        <button
                            className="btn-google"
                            onClick={handleGoogleSignIn}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <i className="fas fa-spinner fa-spin"></i> Entrando...
                                </>
                            ) : (
                                <>
                                    <i className="fab fa-google"></i> Continuar com Google
                                </>
                            )}
                        </button>

                        <div className="popup-divider">
                            <span>ou</span>
                        </div>

                        <button
                            className="btn-email"
                            onClick={() => setShowEmailForm(true)}
                        >
                            <i className="fas fa-envelope"></i> Continuar com Email
                        </button>
                    </div>
                ) : (
                    <div className="popup-body">
                        <form onSubmit={handleEmailSubmit}>
                            <div className="form-group">
                                <input
                                    type="email"
                                    placeholder="seu@email.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="password"
                                    placeholder="Senha (mínimo 6 caracteres)"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            {isSignup && (
                                <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12px', color: '#555', lineHeight: '1.5' }}>
                                    <input
                                        type="checkbox"
                                        id="consent-lgpd"
                                        checked={consentAccepted}
                                        onChange={(e) => setConsentAccepted(e.target.checked)}
                                        style={{ marginTop: '2px', flexShrink: 0, accentColor: 'var(--primary-color)' }}
                                    />
                                    <label htmlFor="consent-lgpd">
                                        Li e concordo com os{' '}
                                        <Link to="/termos-de-uso" onClick={onClose} style={{ color: 'var(--primary-color)', fontWeight: '600' }}>Termos de Uso</Link>
                                        {' '}e a{' '}
                                        <Link to="/politica-de-privacidade" onClick={onClose} style={{ color: 'var(--primary-color)', fontWeight: '600' }}>Política de Privacidade</Link>.
                                    </label>
                                </div>
                            )}
                            <button
                                type="submit"
                                className="btn-submit"
                                disabled={loading || (isSignup && !consentAccepted)}
                            >
                                {loading ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin"></i> {isSignup ? 'Criando conta...' : 'Entrando...'}
                                    </>
                                ) : (
                                    <>
                                        {isSignup ? 'Criar Conta' : 'Entrar'}
                                    </>
                                )}
                            </button>
                        </form>

                        <div className="popup-toggle">
                            {isSignup ? (
                                <p>
                                    Já tem uma conta?{' '}
                                    <button onClick={() => setIsSignup(false)}>Faça login</button>
                                </p>
                            ) : (
                                <p>
                                    Não tem uma conta?{' '}
                                    <button onClick={() => setIsSignup(true)}>Cadastre-se</button>
                                </p>
                            )}
                        </div>

                        <button
                            className="btn-back"
                            onClick={() => setShowEmailForm(false)}
                        >
                            ← Voltar
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoginPopup;
